import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=5b202ac3&scoped=true"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b202ac3",
  null
  
)

export default component.exports